import PropTypes from 'prop-types'
import Modal from '../../common/Modal'
import classNames from 'classnames'
import classes from './CalendarSyncModal.module.scss'
import { ReactComponent as CopyIcon } from '../../../assets/images/common/icons/copy-icon.svg'
import { toast } from 'react-toastify'
import { useEffect, useState } from 'react'
import { requestCalendarToken } from '../../../actions/userActions'
import { useSelector } from 'react-redux'
import Loader from '../../common/loader/Loader'

const CalendarSyncModal = ({ isOpen, onClose, scope }) => {
  const [uuid, setUuid] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const currentUser = useSelector(state => state.user.current_user)

  useEffect(() => {
    requestCalendarToken().then((response) => {
      if (response.status === 200) {
        setUuid(response.data.calendar_uuid)
      }
      setIsLoading(false)
    })
  }, [])

  const apiBase =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_TUNNEL_URL
    : process.env.REACT_APP_API_URL

  const baseUrl = `${apiBase}/api/v1/users/${uuid}/calendar_subscriptions`

  const communityUrl =
    scope === 'family'
      ? `${baseUrl}?scope=family`
      : `${baseUrl}?scope=community`

  const personalUrl = `${baseUrl}?scope=user`

  const handleCopy = (url, type) => {
    navigator.clipboard.writeText(url)
    toast.success(`Copied ${type} calendar link to clipboard!`)
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} className={classNames(classes.modal)}>
      <h1 className={classes.title}>Sync Your Op36 Schedule to a Calendar</h1>

      {isLoading
        ? (
          <Loader>Loading</Loader>
        )
        : (
          <div className={classes.bodyContainer}>
            <p className={classes.description}>
              Never miss a class or 9-hole event. Copy the link below to sync your Op36 schedule
              with your favourite calendar app.
              {scope === 'family'
                ? ' The family calendar shows all events for your family members, while your personal calendar shows only your own events.'
                : ' The community calendar shows all events for all coaches whereas your own personal calendar shows only your coaching events.'}
            </p>

            {!(scope === 'family' && !currentUser.family_admin) && (
              <>
                <div className={classes.label}>{scope === 'family'
                  ? 'Family Calendar URL'
                  : 'Community Calendar URL'}</div>
                <div className={classes.inputWrapper}>
                  <input type='text' readOnly value={communityUrl} />
                  <button
                    onClick={() => handleCopy(communityUrl, scope === 'family' ? 'family' : 'community')}
                    className={classes.copyButton}
                    aria-label='Copy calendar link'
                  >
                    <CopyIcon className={classes.copyIcon} />
                  </button>
                </div>
              </>
            )}

            {!(scope === 'family' && currentUser.family_admin) && (
              <>
                <div className={classes.label}>Personal Calendar URL</div>
                <div className={classes.inputWrapper}>
                  <input type='text' readOnly value={personalUrl} />
                  <button
                    onClick={() => handleCopy(personalUrl, 'personal')}
                    className={classes.copyButton}
                    aria-label='Copy personal calendar link'
                  >
                    <CopyIcon className={classes.copyIcon} />
                  </button>
                </div>
              </>
            )}
          </div>
        )
      }

      <div className={classes.footerContainer}>
        <button className={classes.gotItButton} onClick={onClose}>
          Got It
        </button>
      </div>
    </Modal>
  )
}



CalendarSyncModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  scope: PropTypes.string.isRequired,
}

export default CalendarSyncModal
